module.exports = __webpack_public_path__ + "img/search-not-found.6ac36aa8.svg";